export const EVENTS = {
  USSD: {
    REQUEST_SIMS_LIST: 'REQUEST_SIMS_LIST',
    SIMS_LIST_READY: 'SIMS_LIST_READY',
  }
};
